import Tippy from '@tippyjs/react';
import React, { useRef } from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import 'tippy.js/animations/shift-away-subtle.css';

import { colors } from '../../../Shared/utils';
import { getDeploymentDateTime, getUnknownValue } from '../../../Functions/utils';

// import DeploymentDetails from './DeploymentDetails';



const fixAndParse = (inText) => {
  let fixed = inText;

  fixed = fixed.replace(/[^\x20-\x7F]/g, x => "\\u" + ("000" + x.codePointAt(0).toString(16)).slice(-4));

  fixed = fixed.replace(/\\/g, '\\\\');
  fixed = fixed.replace(/\n/g, ' ');
  fixed = fixed.replace(/\r/g, ' ');
  fixed = fixed.replace(/\t/g, '   ');
  fixed = fixed.replace(/&lt;/g, '<');
  fixed = fixed.replace(/&gt;/g, '>');
  fixed = fixed.replace(/&amp;/g, '&');

  try {
    let jsonFixed = JSON.parse(fixed);

    for (const key of Object.keys(jsonFixed)) {
      jsonFixed[key] = jsonFixed[key].replace(/&quot;/g, '\"');
      jsonFixed[key] = jsonFixed[key].replace(/&apos;/g, '\'');

      var r = /\\u([\d\w]{4})/gi;
      jsonFixed[key] = jsonFixed[key].replace(r, function (match, grp) {
        return String.fromCharCode(parseInt(grp, 16));
      });
    }
    return jsonFixed;
  }
  catch (e) {
    console.log("41 - Error=", e, inText, fixed);
  }
  return {};
}

const DeploymentTooltip = ({ dep, setDeployment }) => {
  const { t } = useTranslation();

  const deployment = dep;

  const biosTxt = deployment.bios_vendor + " " + deployment.bios_version;
  const motherboardTxt = deployment.motherboard_manufacturer + " " + deployment.motherboard_model;

  let cpuTxt = "";
  if (deployment.cpu_text) {
    const cpuList = deployment.cpu_text.substring("&lt;cpu&gt;".length - 1).split('&lt;cpu&gt;');

    cpuList.forEach(cpu => {
      const cpuData = fixAndParse(cpu);
      if (cpuTxt !== "")
        cpuTxt = cpuTxt + " / ";

      cpuTxt += cpuData.manufacturer + " " + cpuData.model + " (" + cpuData.nominal_frequency + ")"
    });
  }

  // GPU
  let gpuTxt = "";
  if (deployment.gpu_text) {
    const gpuList = deployment.gpu_text.substring("&lt;gpu&gt;".length - 1).split('&lt;gpu&gt;');

    gpuList.forEach(gpu => {
      const gpuData = fixAndParse(gpu);
      if (gpuTxt !== "")
        gpuTxt += " / ";

      gpuTxt += gpuData.model;
    });
  }

  // RAM
  let ramTxt = "";
  if (deployment.ram_text) {
    const ramList = deployment.ram_text.substring("&lt;ram&gt;".length - 1).split('&lt;ram&gt;');

    ramList.forEach(ram => {
      const ramData = fixAndParse(ram);
      if (ramTxt !== "")
        ramTxt += " / ";

      ramTxt += ramData.manufacturer + " " + ramData.size + " " + ramData.type;
    });
  }

  // DISK
  let diskTxt = "";
  if (deployment.disk_text) {
    const diskList = deployment.disk_text.substring("&lt;disk&gt;".length - 1).split('&lt;disk&gt;');

    diskList.forEach(disk => {
      const diskData = fixAndParse(disk);
      if (diskTxt !== "")
        diskTxt += " / ";

      diskTxt += diskData.manufacturer + " " + diskData.model + " (" + diskData.size_commercial + ")";
    });
  }

  // NIC
  let nicTxt = "";
  if (deployment.nic_text) {
    const nicList = deployment.nic_text.substring("&lt;nic&gt;".length - 1).split('&lt;nic&gt;');

    nicList.forEach(nic => {
      const nicData = fixAndParse(nic);
      if (nicTxt !== "")
        nicTxt += " / ";

      nicTxt += nicData.manufacturer + " " + nicData.model;
    });
  }

  // SOUND
  let soundTxt = "";
  if (deployment.sound_text) {
    const soundList = deployment.sound_text.substring("&lt;sound&gt;".length - 1).split('&lt;sound&gt;');

    soundList.forEach(sound => {
      const soundData = fixAndParse(sound);
      if (soundTxt !== "")
        soundTxt += " / ";

      soundTxt += soundData.model;
    });
  }

  // CDDVD
  let cddvdTxt = "";
  if (deployment.cddvd_text) {
    const cddvdList = deployment.cddvd_text.substring("&lt;cddvd&gt;".length - 1).split('&lt;cddvd&gt;');

    cddvdList.forEach(cddvd => {
      const cddvdData = fixAndParse(cddvd);
      if (cddvdTxt !== "")
        cddvdTxt += " / ";

      cddvdTxt += cddvdData.model;
    });
  }

  return (<>

    <div>
      <div className="deployment__category">
        <span>{t('realtime.deployment.info.bios')}{t('global.colon')} </span>{biosTxt}
      </div>
    </div>

    <div>
      <div className="deployment__category">
        <span>{t('realtime.deployment.info.motherboard')}{t('global.colon')} </span>{motherboardTxt}
      </div>
      <div className="deployment__category">
        <span>{t('realtime.deployment.info.cpu')}{t('global.colon')} </span>{cpuTxt}
      </div>
      <div className="deployment__category">
        <span>{t('realtime.deployment.info.gpu_card')}{t('global.colon')} </span>
        {getUnknownValue(gpuTxt, t, 'e')}
      </div>
    </div>

    <div>
      <div className="deployment__category">
        <span>{t('realtime.deployment.info.ram')}{t('global.colon')} </span>{deployment.ram_MB}
      </div>
      <div className="deployment__category">
        <span>{t('realtime.deployment.info.fixed_disk')}{t('global.colon')} </span>{diskTxt}
      </div>
    </div>

    <div>
      <div className="deployment__category">
        <span>{t('realtime.deployment.info.nic')}{t('global.colon')} </span>{nicTxt}
      </div>
      <div className="deployment__category">
        <span>{t('realtime.deployment.info.sound_card')}{t('global.colon')} </span>
        {soundTxt}
      </div>
      <div className="deployment__category">
        <span>{t('realtime.deployment.info.optic_drive')}{t('global.colon')} </span>{cddvdTxt || t('global.none')}
      </div>
    </div>

    {/* <span className="deployment__category">
      <span>{t('realtime.deployment.info.brand')}{t('global.colon')} </span>
      {dep.manufacturer}
    </span>

    <span className="deployment__category">
      <span>{t('realtime.deployment.info.serial')}{t('global.colon')} </span>
      {dep.serial}
    </span>

    <span className="deployment__category">
      <span>{t('realtime.deployment.info.mac')}{t('global.colon')} </span>
      {dep.mac}
    </span>

    <span className="deployment__category" title={dep.product}>
      <span>{t('realtime.deployment.info.product')}{t('global.colon')} </span>
      {dep.product}
    </span>

    {dep.error_module_result_data && (
      <span className="deployment__category" title={dep.error_module_result_data} style={{ marginTop: '11px' }}>
        <span style={{ color: colors.error }}>{t('realtime.deployment.info.error')}{t('global.colon')} </span>
        &quot;{dep.error_module_result_data}&quot;
      </span>
    )}

    <Button
      className="button"
      onClick={() => setDeployment(dep)}
      style={{ margin: '5px auto', width: '100%', background: 'var(--button-bg)' }}
    >
      {t('realtime.deployment.info.view_more')}
    </Button> */}
  </>);
};



export default function Deployment({ dep, setDeployment }) {
  const { t } = useTranslation();
  const date = useRef(getDeploymentDateTime(dep.date));

  // let panelForDbClick = document.getElementById("deploymentPanel");

  // if (panelForDbClick) {
  //   panelForDbClick.ondblclick = function () {
  //     console.log("65 - deploymentPanel=", panelForDbClick);
  //   }
  // }
  // console.log("68 - panelForDbClick=", panelForDbClick);

  return (
    <div className="deployment">
      <img src={`/assets/images/realtime/pc_brand_${dep.brand}.png`} alt={dep.manufacturer} />
      {dep.current_module_name && (
        <div className="deployment__module">
          <span title={dep.current_module_name}>{dep.current_module_name}</span>
        </div>
      )}

      <Tippy
        interactive
        theme='light'
        placement="right-end"
        animation="shift-away-subtle"
        content={
          <DeploymentTooltip dep={dep} setDeployment={setDeployment} />
        }
        offset={[0, 20]} // Fix issue where the pop-up disappears before hovering it
      >
        <div className="deployment__info">
          <span>
            <p>{t('global.months.' + date.current.month, { day: date.current.day })}</p>
            <p>{date.current.time}</p>
          </span>
          <span
            className="material-icons-outlined"
            style={{ fontSize: '26px', color: colors[dep.error_module_result_data ? 'error' : 'success'] }}
          >info</span>
        </div>

      </Tippy>
    </div>
  );
}
